import {
  InputContainer,
  LabelStyled,
} from "components/form/inputs/inputs.styled";
import { SettingsSelect } from "components/form/select/select.styled";
import { CustomIcon } from "components/icon/customIcon.component";
import { CustomLink, H4, Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { isSettingEnabled } from "model/settings.logic";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { TermsAndPrivacy } from "../companySubscription/termsAndPrivacy.component";
import {
  RowWrapper,
  Slide,
  SlideShow,
  SlideShowWrapper,
  TermsContainer,
} from "./companySettingsMobileView.styled";

type Props = {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  slide: string | null;
  children: JSX.Element;
};

export const CompanySettingsMobileView: React.FC<Props> = ({
  page,
  setPage,
  slide,
  children,
}) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const history = useHistory();
  const [companyState] = useCompanyStore();

  const haveOBModule = useMemo(() => {
    return isSettingEnabled(
      companyState.companySettings,
      "CompanyShowInconvenientModule",
    );
  }, [companyState.companySettings]);

  const haveTipModule = useMemo(() => {
    return isSettingEnabled(
      companyState.companySettings,
      "CompanyShowTipModule",
    );
  }, [companyState.companySettings]);

  return (
    <SlideShowWrapper>
      <SlideShow page={page}>
        <Slide>
          <H4 fontFamily={FontFamily.LeagueSpartanBold}>
            {t("General.Settings")}
          </H4>
          <InputContainer>
            <LabelStyled>{t("ProfileCompany.Company")}</LabelStyled>
            <SettingsSelect
              onClick={() => {
                setPage(1);
                history.push(`${path}?page=profile`);
              }}
            >
              <CustomIcon
                name="person"
                size="48px"
                color={Color.BurntSienna}
                padding="10px"
              />
              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("ProfileCompany.Profile")}
              </Text>
            </SettingsSelect>
            <SettingsSelect
              onClick={() => {
                setPage(1);
                history.push(`${path}?page=details`);
              }}
            >
              <CustomIcon
                name="document"
                size="48px"
                color={Color.BurntSienna}
                padding="10px"
              />
              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("ProfileCompany.Details")}
              </Text>
            </SettingsSelect>
            <SettingsSelect
              onClick={() => {
                setPage(1);
                history.push(`${path}?page=users`);
              }}
            >
              <CustomIcon
                name="person"
                size="48px"
                color={Color.BurntSienna}
                padding="10px"
              />
              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("CompanyUsers.CompanyUsers")}
              </Text>
            </SettingsSelect>
            {haveOBModule && (
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=Ob`);
                }}
              >
                <CustomIcon
                  name="clock"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />

                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("ProfileCompany.OB")}
                </Text>
              </SettingsSelect>
            )}
            <SettingsSelect
              onClick={() => {
                setPage(1);
                history.push(`${path}?page=Subscription`);
              }}
            >
              <CustomIcon
                name="wallet"
                size="48px"
                color={Color.BurntSienna}
                padding="10px"
              />

              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("ProfileCompany.Subscription")}
              </Text>
            </SettingsSelect>
            {haveTipModule && (
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=Tip`);
                }}
              >
                <CustomIcon
                  name="cashier"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />
                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("CompanyTip.Tip")}
                </Text>
              </SettingsSelect>
            )}
            <SettingsSelect
              onClick={() => {
                setPage(1);
                history.push(`${path}?page=System`);
              }}
            >
              <CustomIcon
                name="settings"
                size="48px"
                color={Color.BurntSienna}
                padding="10px"
              />

              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("System.System")}
              </Text>
            </SettingsSelect>
          </InputContainer>
          <InputContainer>
            <LabelStyled>{t("General.Simflexity")}</LabelStyled>
            <SettingsSelect
              onClick={() => {
                window.open(`https://www.simflexity.com/kontakt`);
              }}
            >
              <CustomIcon
                name="mail"
                size="48px"
                padding="10px"
                color={Color.BurntSienna}
              />
              <Text
                fontSize={FontSize.H4}
                fontFamily={FontFamily.MontserratSemiBold}
              >
                {t("General.ContactSupport")}
              </Text>
            </SettingsSelect>
          </InputContainer>

          <TermsContainer>
            <TermsAndPrivacy />
          </TermsContainer>
        </Slide>
        <Slide>
          {children}
          {slide && (
            <RowWrapper>
              <CustomLink color={Color.Destructive} to={"./settings"}>
                {t("General.Cancel")}
              </CustomLink>
            </RowWrapper>
          )}
        </Slide>
      </SlideShow>
    </SlideShowWrapper>
  );
};
